export default {
  MISSION: 'mission',
  CATEGORY: 'category',
  DEADLINE: 'task',
  TASK: 'task',
};
